var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYouTube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-YouTube") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-YouTube",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6005331,8.00059563 C13.8669714,8.00568651 19.653402,8.05150437 21.2276515,8.46386513 C22.20471,8.71907148 22.9741511,9.47190115 23.2356174,10.427617 C23.6507775,11.942941 23.7026725,14.8990056 23.7091594,15.6143448 L23.7099703,15.7319933 C23.7100861,15.7588828 23.7100861,15.7729983 23.7100861,15.7729983 L23.7100716,15.7834173 C23.7100572,15.7903074 23.7100282,15.8005586 23.7099703,15.8140034 L23.7091594,15.9316519 C23.7026725,16.6469911 23.6507775,19.6030556 23.2356174,21.1183797 C22.9741511,22.0740955 22.20471,22.8269252 21.2276515,23.0821315 C19.653402,23.4944923 13.8669714,23.5403102 12.6005331,23.545401 L12.3955433,23.5459967 C12.3685772,23.5460374 12.3545484,23.5460374 12.3545484,23.5460374 L12.3441641,23.5460323 C12.3372868,23.5460272 12.3270389,23.546017 12.313557,23.5459967 L12.1085842,23.545401 C10.842251,23.5403102 5.05629314,23.4944923 3.48204363,23.0821315 C2.50498514,22.8269252 1.73494578,22.0740955 1.47407775,21.1183797 C1.05891764,19.6030556 1.00702262,16.6469911 1.00053575,15.9316519 L1.00053575,15.6143448 C1.00702262,14.8990056 1.05891764,11.942941 1.47407775,10.427617 C1.73494578,9.47190115 2.50498514,8.71907148 3.48204363,8.46386513 C5.05629314,8.05150437 10.842251,8.00568651 12.1085842,8.00059563 Z M9.79076146,12.9464387 L9.79076146,19.3061979 L15.6515297,16.1263183 L9.79076146,12.9464387 Z",
    id: "Combined-Shape",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.5c896b2f.svg";
export { ForwardRef as ReactComponent };